<template>
    <SelectDropDown
            :id="id"
            :name="name"
            :label="label"
            @selection-change="statusSelected"
            :options="statuses"
            :defaultSelected="defaultSelected ? {id: defaultSelected.enumName} : statuses[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import {mapGetters} from 'vuex';

    export default {
        name: "CarStatusDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String,
            label: String,
            defaultSelected: Object
        },
        created() {
            this.setStatuses();
        },
        data() {
            return {
                statuses: []
            }
        },
        methods: {
            statusSelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValue: value.currentValue.id === 'none' ? '' : value.currentValue.name,
                    currentValueId: value.currentValue.id,
                    oldValue: value.oldValue
                });
            },
            setStatuses() {
                this.statuses = [];
                this.statuses.push({
                    id: 'none',
                    name: '(всички)'
                });
                if (this.carStatuses && Array.isArray(this.carStatuses)) {
                    this.carStatuses.forEach(status => {
                        status.id = status.enumName;
                        this.statuses.push(status)
                    });
                }
            }
        },
        computed: {
            ...mapGetters(['carStatuses'])
        },
        watch: {
            carStatuses: {
                handler() {
                    this.setStatuses();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
